import React from "react";
import { Card, Input, Button, Typography } from "antd";
import "./ForgotPasswordPage.css";

const { Title, Text, Link } = Typography;

const ForgotPasswordPage = () => {
  return (
    <div className="forgot-container">
      <Card className="forgot-card">
        <div className="logo-container">
          <img src={require("../../assets/logo.png")} alt="logo" />
        </div>
        <Title level={3}>Forgot Password</Title>
        <Text type="secondary">
          Enter your email and we’ll send you a password reset link.
        </Text>

        <div className="form-item">
          <Text strong>Email or Username</Text>
          <Input placeholder="Enter your email or username" />
        </div>

        <Button type="primary" block className="forgot-button">
          Send Reset Link
        </Button>

        <div className="signin-text">
          Remember your password? <Link href="#">Sign in</Link>
        </div>
      </Card>
    </div>
  );
};

export default ForgotPasswordPage;
